import type { TypographyVariantsOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    poster: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    poster?: React.CSSProperties;
  }
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    poster: true;
  }
}

export const typography: TypographyVariantsOptions = {
  fontFamily: "Averta, Helvetica Neue, Helvetica, Arial, Roboto, sans-serif",
  h1: {
    fontSize: 50,
  },
  poster: {
    fontSize: 30,
  },
  subtitle1: {
    fontSize: 21,
  },
};
